import { Component, OnInit } from '@angular/core';
import { RegisterStepOneBaseComponent } from '../register-step-one-base.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-blu-registration',
  templateUrl: './blu-registration.component.html',
  styleUrls: ['./blu-registration.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule]
  
})
export class BluRegistrationComponent extends  RegisterStepOneBaseComponent {
    
}

